import { Assets, Rectangle, Spritesheet, Texture, type Renderer, type SpritesheetData } from "pixi.js";

/** Fixed 5 MiB atlas, shared by rocks, terrain contacts and destruction effects. */
export async function loadRockEnvironment(textures: Record<string, Texture>, renderer: Renderer): Promise<void> {
    const { sheet: data } = await Assets.load<{ sheet: SpritesheetData }>("/img/momo/rocks-49/manifest.json");
    if (data.meta.size?.w !== 1024 || data.meta.size?.h !== 1280 || !data.meta.image) throw new Error("Invalid rock atlas");
    const atlas = await Assets.load<Texture>(data.meta.image);
    await renderer.prepare.upload(atlas);
    const frames = await new Spritesheet(atlas, data).parse();
    for (const [name, frame] of Object.entries(frames)) {
        const size = (data.frames[name] as typeof data.frames[string] & { worldPixels: number }).worldPixels;
        textures[name] = new Texture({ source: frame.source, frame: frame.frame.clone(), orig: new Rectangle(0, 0, size, size), label: `momo-rock49:${name}` });
        if (name.includes("_particle_")) textures[`momo_${name}`] = textures[name];
    }
    document.documentElement.dataset.momoRockRevision = "49";
}
